// Import
import $ixios from '../shared/ixios-instance.js'
import config from '../config'


export default {
  /* *****************************************************************************************************
  * State
  */
  state: {
    case: {},
    step: 1,
    user: {
      id: 976064,
      name: 'Stefan Keller'
    },
    track: {},
    isStepsVisible: true,
    isSurgicalModalVisible: false,
    isRestorativeModalVisible: false
  },
  /* *****************************************************************************************************
  * Getters for actions
  *
  */
  getters: {
    getDirectAction: state => params => {

      var action = {
        actor: {
          id: state.user.id,
          name: state.user.name
        },
        verb: {
          id: 'action',
          display: 'action'
        },
        object: {
          direct: params,
          indirect: {
            id: 0,
            name: '',
            to: {
              id: '',
              display: ''
            }
          }
        }

      };

      return action;
    }
  },
  /* *****************************************************************************************************
  * Mutations
  * list of mutations
  */
  mutations: {
    authorize (state, data) {
      $ixios.defaults.headers.common['Authorization'] = `Bearer ${data}`;
    },
    /* ***********************************************************
    * Set case
    * active the application using the information after login
    */
    case (state, content) {
      state.case = content;
      $ixios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
    },
    next (state, content) {
      state.step += 1;
    },
    track (state, content) {
      state.track = content;
    },
    surgicalModal (state, isModalShown) {
      state.isStepsVisible = !isModalShown;
      state.isSurgicalModalVisible = isModalShown;
    },
    restorativeModal (state, isModalShown) {
      state.isStepsVisible = !isModalShown;
      state.isRestorativeModalVisible = isModalShown;
    }
  },
  /*****************************************************************************
  * Actions
  *
  */
  actions: {
    /* ***********************************************************
    * Case
    */
    case ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        $ixios.get(`${config.baseUrl}${config.apiPath}casecloud/cases/${payload.id}`, { params: {} })
          .then(response => {
            //

            commit('case', response.data.data)
            resolve(response)
          })
          .catch(error => {
            commit('case', {})
            reject(error)
          })
      })
    },
    create ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        $ixios.put('casecloud/cases', { params: payload })
          .then(response => {
            //

            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    update ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        $ixios.post('casecloud/cases/' + payload.id + '/' + payload.part, { params: payload.params })
          .then(response => {
            //

            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    upload ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        $ixios.post('casecloud/cases/' + payload.id + '/images', payload.data , { headers: { 'Content-Type': 'multipart/form-data'}})
          .then(response => {
            //

            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    deleteParagraph ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        $ixios.delete('casecloud/cases/' + payload.caseid + '/paragraphs/' + payload.paragraphid, {})
          .then(response => {
            //
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    /* ***********************************************************
    * SAC
    */
    track ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        $ixios.get('sac/assessments/1/' + payload.id, {})
          .then(response => {
            //
            commit('track', response.data.data)
            resolve(response)
          })
          .catch(error => {
            commit('track', {})
            reject(error)
          })
      })
    },
    surgicalModalAction({ commit }, isModalShown){
      commit('surgicalModal', isModalShown)
    },
    restorativeModalAction({ commit }, isModalShown){
      commit('restorativeModal', isModalShown)
    }
  }
}
